/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_Point_4Inputs */

const en_guestlist_point_4 = /** @type {(inputs: Guestlist_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask Claude: it works with your Guestlist, with your permissions`)
};

/**
* | output |
* | --- |
* | "Ask Claude: it works with your Guestlist, with your permissions" |
*
* @param {Guestlist_Point_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_point_4 = /** @type {((inputs?: Guestlist_Point_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_Point_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_point_4(inputs)
});